
import FilterBase from "./filterBase.js";

export default class Grayscale extends FilterBase {
    objectType = "GrayscaleFilterItem";

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        if (args.tooltip == null) {
            args.tooltip = "Convertit l'image en noir et blanc";
        }
        super.objectToClassValue(args);
    }

    static get Name() {
        return "Grayscale";
    }

    async filterAction(cv, cvImage) {
        cv.cvtColor(cvImage, cvImage, cv.COLOR_BGRA2GRAY);
        cv.cvtColor(cvImage, cvImage, cv.COLOR_GRAY2BGRA);
        return cvImage;
    }
}